export default __webpack_public_path__ + "static/BillPrevity-f1300cd6eef09925ca1e6a959fb1d679.jpg";